import React, { Component } from 'react';
import { Link } from 'react-router-dom'

class Customers extends Component{
  constructor() {
    super();
    this.state = {
      firstCustomers: [],
      customers: []
    }

    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.handleIdChange = this.handleIdChange.bind(this)
  }


  handleEmailChange(event) {
    const value = event.target.value.toLowerCase()
    if (value.length > 0) {
      const searchResult = this.state.firstCustomers.filter(customer =>
        customer.email.toLowerCase().includes(value)
      );
      this.setState({customers: searchResult})
    } else {
      this.setState(prevState => ({customers: prevState.firstCustomers}))
    }
  }

  handleNameChange(event) {
    const value = event.target.value.toLowerCase()
    if (value.length > 0) {
      const searchResult = this.state.firstCustomers.filter(customer => {
        const customerName = `${customer.first_name} ${customer.last_name}`
        if (customerName.toLowerCase().includes(value)) {
          return customer
        }
      })
      if (searchResult[0] !== undefined) {
        this.setState({customers: searchResult})
      } else {
        this.setState({customers: []})
      }
    } else {
      this.setState(prevState => ({customers: prevState.firstCustomers}))
    }
  }

  handleIdChange(event) {
    const value = event.target.value
    if (isNaN(value)) {
      this.setState(prevState => ({customers: prevState.firstCustomers}))
    } else {
      const searchResult = this.state.firstCustomers.filter(customer => {
          const idString = customer.id.toString()
          return idString.startsWith(value)
        }
      );
      this.setState({customers: searchResult})
    }
  }

  componentDidMount() {
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    headers["Authorization"] = `Token ${token}`;
    fetch("/api/admin/customers", {headers, method: "GET"})
      .then(res => {
        if (res.status === 200) {
          res.json().then(customers => {
            this.setState({firstCustomers: customers, customers: customers})
          })
        }  else {
          console.log("Server Error!");
        }
      })
  }

  render() {
    return(
      <div className="Customers">
        <h1>Customers</h1>
        <Link
          className="Add-btn"
          to="/backoffice/customers/create">
          Lägg till ny
        </Link>
        <h4>Antal kunder: {this.state.firstCustomers.length}</h4>
        <div className="Products-body">
          <table>
            <thead>
              <tr>
                <th className="t-a-center">(index) - ID</th>
                <th>Email</th>
                <th>Name</th>
                <th>Aldrig loggat in</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="d-flex">
                  <input
                    type="text"
                    className="table-input small"
                    placeholder="ID"
                    onChange={this.handleIdChange} />
                </td>
                <td className="p-r-20">
                  <input
                    type="text"
                    className="table-input"
                    placeholder="Email"
                    onChange={this.handleEmailChange} />
                </td>
                <td className="p-r-20">
                  <input
                    type="text"
                    className="table-input"
                    placeholder="Name"
                    onChange={this.handleNameChange}/>
                </td>
                <td></td>
                <td></td>
              </tr>
              {
                this.state.customers.map((item, index) => {
                  return(
                    <tr key={item.id}>
                      <td className="t-a-center">({index + 1}) - {item.id}</td>
                      <td>{item.email}</td>
                      <td>{item.first_name} {item.last_name}</td>
                      <td>{item.first_login.toString()}</td>
                      <td>
                        <Link to={`customers/${item.id}`} className="table-button">Visa</Link>
                      </td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

export default Customers;



// WEBPACK FOOTER //
// ./src/containers/admin/containers/Customers.jsx